import React from 'react'
import { useTrans } from '@next-nx/hooks'
import { OffertaType } from '@next-nx/utils/types'
import {
  CaratteristicheAlimentazione,
  CaratteristicheCambio,
  CaratteristicheCategoria,
  CaratteristicheConsumi,
  CaratteristicheEmissioni,
  CaratteristicheKw,
  CaratteristicheNote,
  CaratteristicheOptional,
} from '@next-nx/shared-ui/icons'
import { Button, WContainer } from '@next-nx/shared-ui/atoms'
import styles from './ComparatoreTable.module.sass'
import { getCategoriaUrlParam } from '@next-nx/utils'
import { useRouter } from 'next/router'

interface Props {
  items?: OffertaType[]
  maxItems?: number
  className?: string
  handleTracking?: (type: string, effect: string, cta: string, product?: string) => void
}

const ComparatoreTable = (props: Props) => {
  const { items = [], maxItems = 3, className = '', handleTracking = () => undefined } = props

  const t = useTrans()
  const router = useRouter()

  const parametri = [
    {
      chiave: 'categoria',
      icon: <CaratteristicheCategoria />,
      label: t('Categoria'),
      getValue: (o: OffertaType) => o.veicolo.categoria?.nome,
    },
    {
      chiave: 'alimentazione',
      icon: <CaratteristicheAlimentazione />,
      label: t('Alimentazione'),
      getValue: (o: OffertaType) => o.veicolo.alimentazione,
    },
    {
      chiave: 'kw',
      icon: <CaratteristicheKw />,
      label: t('KW'),
      getValue: (o: OffertaType) => o.veicolo.potenzaKw,
    },
    {
      chiave: 'cambio',
      icon: <CaratteristicheCambio />,
      label: t('Cambio'),
      getValue: (o: OffertaType) => o.veicolo.cambio,
    },
    {
      chiave: 'consumi',
      icon: <CaratteristicheConsumi />,
      label: t('Consumi'),
      getValue: (o: OffertaType) => o.veicolo.consumi,
    },
    {
      chiave: 'emissioni',
      icon: <CaratteristicheEmissioni />,
      label: t('Emissioni'),
      getValue: (o: OffertaType) => o.veicolo.ecoImpactCo2,
    },
    {
      chiave: 'optional',
      icon: <CaratteristicheOptional />,
      label: t('Optional'),
      getValue: (o: OffertaType) => o.veicolo.optional,
    },
    {
      chiave: 'note',
      icon: <CaratteristicheNote />,
      label: t('Note'),
      getValue: (o: OffertaType) => o.note,
    },
  ]

  return items.length > 1 ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <p className={styles.title}>{t('Caratteristiche veicoli selezionati')}</p>
        <div className={styles.table}>
          {parametri.map((p) => (
            <div className={styles.row} key={p.chiave}>
              {[...Array(maxItems)].map((x, i) => (
                <div className={styles.cell} key={`${p.chiave}_${i}`}>
                  {items.length > i && (
                    <div className={styles.item}>
                      <div className={styles.itemIcon}>{p.icon}</div>
                      <div className={styles.itemContent}>
                        <span className={styles.itemLabel}>{p.label}</span>
                        <span className={styles.itemValue}>{p.getValue(items[i]) || '-'}</span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
          <div className={`${styles.row} ${styles["row--actions"]}`}>
            {[...Array(maxItems)].map((x, i) => (
              <div className={styles.cell} key={i}>
                {items.length > i && (
                  <Button
                    label={t('Configura veicolo')}
                    labelMobile={t('Configura')}
                    href={items[i].url + getCategoriaUrlParam(router?.query?.categoria)}
                    handleTracking={() => handleTracking('configura_veicolo', 'configurazione_veicolo_comparatore', 'configura_veicolo_comparatore', items[i]?.nome)}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default ComparatoreTable
